import { APP_NAME } from '../utils/environment';
import { default as module } from './AbstractModule';
import { $document, $window } from '../utils/environment'
import VimeoPlayer from '@vimeo/player';

const MODULE_NAME     = 'VideoReel';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK:  `click.${EVENT_NAMESPACE}`,
    RESIZE: `resize.${EVENT_NAMESPACE}`,
};


export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: "close",
                sound: "toggleMute"
            }
        }

        this.$iframe = this.$('iframe')
        this.$sound = this.$('sound')

        this.resize();
    }

    init() {
        this.isMute = true

        this.player = new VimeoPlayer(this.$iframe)
    }

    playVideo() {
        this.player.setCurrentTime(0);
        this.player.play();
    }

    pausedVideo() {
        this.player.pause();
    }

    toggleMute() {
        if(this.isMute) {
            this.mute()
        } else {
            this.unMute()
        }
    }

    mute() {
        this.isMute = false
        this.player.setVolume(0);
        this.$sound.classList.add('-mute')
    }

    unMute() {
        this.isMute = true
        this.player.setVolume(1);
        this.$sound.classList.remove('-mute')
    }

    resize() {
        let screenRatio = window.innerWidth / window.innerHeight;

        // // let iframeBCR = this.$iframe[0].getBoundingClientRect()
        let iframeRatio = 16 / 9;

        if (window.innerWidth < 1000 && window.innerWidth / window.innerHeight < 1) {
            TweenMax.set(this.$iframe, {width: window.innerWidth, height: window.innerWidth * (1 / iframeRatio)});
        } else {
            if (screenRatio > iframeRatio) { // stretch width
                TweenMax.set(this.$iframe, {width: window.innerWidth, height: window.innerWidth * (1 / iframeRatio)});
            } else { // stretch height
                TweenMax.set(this.$iframe, {width: window.innerHeight * iframeRatio, height: window.innerHeight});
            }
        }
    }

    close() {
        this.call('close', null, 'Videoreeltoggler')
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $document.off(`.${EVENT_NAMESPACE}`);
        $window.off(`.${EVENT_NAMESPACE}`);

        this.player.destroy();
        this.player = null;
    }
}
